module.exports = __webpack_public_path__ + "img/loginLogo3.9738d25b.png";